import AmberFinLogo from './img/AmberFinLogo.png';
import './App.css';
import {Button, Col, Divider, Popover, Row, Typography} from 'antd';
import ReactCountryFlag from "react-country-flag";
import {
    InfoCircleOutlined, LinkedinOutlined,
} from "@ant-design/icons";
import {NavLink} from "react-router-dom";


const { Title, Text } = Typography;

function Footer() {
    return (
        <>
            <Divider/>
            <Row style={{
                minHeight: 220,
                maxWidth: 1024,
                margin: '12px auto 0 auto',
                padding: '0 12px'
            }}
                className={"footer"}>
                
                <Col
                    xs={24}
                    sm={24}
                    md={6}
                    lg={6}
                >
                    <Text style={{ fontWeight: "bold", marginBottom:16, display: "block"}}>Company</Text>
                    <NavLink className={"menu"} to={'/about'} >About</NavLink>
                    <NavLink className={"menu"} to={'/contacts'} to={'/contacts'} >Contacts</NavLink>
                    <NavLink className={"menu"} to={'/contacts'} to={'/contacts'} >Chat</NavLink>
                    <NavLink className={"menu"} to={'/contacts'} to={'/contacts'} >Social</NavLink>
                </Col>
                <Col
                    xs={24}
                    sm={24}
                    md={6}
                    lg={6}
                >
                        <Text style={{ fontWeight: "bold", marginBottom:16, display: "block"}}>Legal</Text>
                        <p><a href={'/'} style={{display: "block"}}>Privacy</a></p>
                        <p><a href={'/'} style={{display: "block"}}>Cookie policy</a></p>
                        <p><a href={'/'} style={{display: "block"}}>Terms of Use</a></p>
                        <p><a href={'/'} style={{display: "block"}}>Regulatory Disclosures</a></p>
                        <p><a href={'/'} style={{display: "block"}}>Prohibited businesses types</a></p>
                </Col>
                <Col
                    xs={24}
                    sm={24}
                    md={6}
                    lg={6}
                >
                        <Text style={{fontWeight: "bold", marginBottom: 16, display: "block"}}>For Developers</Text>
                        <p><a href={'/'} style={{display: "block"}}>API Documentation</a></p>
                        <p><a href={'/'} style={{display: "block"}}>SaaS</a></p>
                </Col>
                <Col
                    xs={24}
                    sm={24}
                    md={6}
                    lg={6}
                >
                        <Text style={{fontWeight: "bold", marginBottom:16, display: "block"}}>For Business</Text>
                        <p><a href={'/'} style={{display: "block"}}>Account Management</a></p>
                </Col>
            </Row>

        <Row
            style={{
                maxWidth: 1024,
                margin: '64px auto 0 auto',
                padding: '0 12px'
            }}>
            <Col span={12}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <img
                        src={AmberFinLogo}
                        style={{maxWidth: '18px', marginRight: 18}}
                    />
                    <small style={{fontSize: 10}}><strong>AMBER</strong>TECHNOLOGIES</small>
                </div>
            </Col>
            <Col
                span={12}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    textAlign:'right',
                    fontSize: 22,
                }}>
                <LinkedinOutlined style={{marginLeft: 'auto'}} />
            </Col>
            <Divider />

        </Row>
        <Row
            style={{
                minHeight: 220,
                maxWidth: 1024,
                margin: '0px auto',
                padding: '0 12px',
            }}
        >
            <Col span={24}>
                      <span>
                          <small> © Amber Information Technologies. All rights reserved. &nbsp;&nbsp;</small></span>

                <ReactCountryFlag
                    countryCode="LT"
                    svg
                    style={{
                        width: '1em',
                        height: '1em',
                    }}
                    title="Lithuania"
                />
                <span> <small> Lietuva | Lithuania</small></span>
            </Col>
        </Row>
        </>
    );
}

export default Footer;
